import { Check } from '@phosphor-icons/react';

interface Step {
  label: string;
  status: 'completed' | 'current' | 'upcoming';
}

interface StepperProps {
  steps: Step[];
}

export function Stepper({ steps }: StepperProps) {
  return (
    <div className="flex items-center justify-center gap-2 mb-8">
      {steps.map((step, index) => (
        <div key={index} className="flex items-center">
          <div className="flex flex-col items-center">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 transition-all ${
              step.status === 'completed' 
                ? 'bg-primary border-primary text-primary-foreground' 
                : step.status === 'current'
                ? 'bg-background border-primary text-primary'
                : 'bg-background border-muted-foreground/30 text-muted-foreground'
            }`}>
              {step.status === 'completed' ? (
                <Check className="w-5 h-5" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className={`mt-2 ${
              step.status === 'upcoming' ? 'text-muted-foreground' : 'text-foreground'
            }`}>
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div className={`w-16 h-0.5 mb-6 mx-2 ${
              step.status === 'completed' ? 'bg-primary' : 'bg-muted-foreground/30'
            }`} />
          )}
        </div>
      ))}
    </div>
  );
}
